// @flow
import update from 'immutability-helper';
import reservedReducer, {
  initialState as reservedInitialState,
  actions as reservedActions,
} from './reserved/duck';
import receivedReducer, {
  initialState as receivedInitialState,
  actions as receivedActions,
} from './received/duck';
import purchasedReducer, {
  initialState as purchasedInitialState,
  actions as purchasedActions,
} from './purchased/duck';
import deliverReducer, {
  initialState as deliverInitialState,
  actions as deliverActions,
} from './deliver/duck';
import completedReducer, {
  initialState as completedInitialState,
  actions as completedActions,
} from './completed/duck';

import type { ReservedState } from './reserved/duck';
import type { ReceivedState } from './received/duck';
import type { PurchasedState } from './purchased/duck';
import type { CompletedState } from './completed/duck';
import type { DeliverState } from './deliver/duck';

type SaleAction = {
  +type: string;
};

export type SaleState = {
  +reserved: ReservedState;
  +received: ReceivedState;
  +purchased: PurchasedState;
  +deliver: DeliverState;
  +completed: CompletedState;
};

// Actions

// Action Creators

export const initialState: SaleState = {
  reserved: reservedInitialState,
  received: receivedInitialState,
  purchased: purchasedInitialState,
  deliver: deliverInitialState,
  completed: completedInitialState,
};

// Reducer
export default function reducer(state: SaleState = initialState,
                                action: SaleAction): SaleState {
  switch (action.type) {
    case reservedActions.RESERVED_UPLOAD_INVOICE_FILE_REQUEST:
    case reservedActions.RESERVED_UPLOAD_INVOICE_SUCCESS:
    case reservedActions.RESERVED_UPLOAD_INVOICE_ERROR:
    case reservedActions.RESERVED_PROGRESS_PURCHASE_REQUEST:
    case reservedActions.RESERVED_PROGRESS_PURCHASE_SUCCESS:
    case reservedActions.RESERVED_PROGRESS_PURCHASE_ERROR:
    case reservedActions.RESERVED_CANCEL_RESERVATION_REQUEST:
    case reservedActions.RESERVED_CANCEL_RESERVATION_SUCCESS:
    case reservedActions.RESERVED_CANCEL_RESERVATION_ERROR:
      return update(state, {
        reserved: { $set: reservedReducer((state: any).reserved, (action: any)) },
      });
    case receivedActions.RECEIVED_POST_ARRIVED_REQUEST:
    case receivedActions.RECEIVED_POST_ARRIVED_SUCCESS:
    case receivedActions.RECEIVED_POST_ARRIVED_ERROR:
      return update(state, {
        received: { $set: receivedReducer(state.received, (action: any)) },
      });

    case purchasedActions.PURCHASED_POST_SET_TRACKING_NUMBER_REQUEST:
    case purchasedActions.PURCHASED_POST_SET_TRACKING_NUMBER_SUCCESS:
    case purchasedActions.PURCHASED_POST_SET_TRACKING_NUMBER_ERROR:
    case purchasedActions.PURCHASED_POST_CONFIRM_ITEM_RECEIVED_REQUEST:
    case purchasedActions.PURCHASED_POST_CONFIRM_ITEM_RECEIVED_SUCCESS:
    case purchasedActions.PURCHASED_POST_CONFIRM_ITEM_RECEIVED_ERROR:
    case purchasedActions.PURCHASED_POST_PROGRESS_RECEIVE_REQUEST:
    case purchasedActions.PURCHASED_POST_PROGRESS_RECEIVE_SUCCESS:
    case purchasedActions.PURCHASED_POST_PROGRESS_RECEIVE_ERROR:
    case purchasedActions.PURCHASED_FETCH_CANCELATION_MOTIVES_REQUEST:
    case purchasedActions.PURCHASED_FETCH_CANCELATION_MOTIVES_SUCCESS:
    case purchasedActions.PURCHASED_FETCH_CANCELATION_MOTIVES_ERROR:
    case purchasedActions.PURCHASED_CANCEL_ITEM_REQUEST:
    case purchasedActions.PURCHASED_CANCEL_ITEM_SUCCESS:
    case purchasedActions.PURCHASED_CANCEL_ITEM_ERROR:
      return update(state, {
        purchased: { $set: purchasedReducer(state.purchased, (action: any)) }
      });
    case deliverActions.DELIVER_POST_PROGRESS_COURIER_REQUEST:
    case deliverActions.DELIVER_POST_PROGRESS_INVOICE_SUCCESS:
    case deliverActions.DELIVER_POST_PROGRESS_QEMPO_REQUEST:
    case deliverActions.DELIVER_POST_PROGRESS_SUCCESS:
    case deliverActions.DELIVER_POST_PROGRESS_ERROR:
    case deliverActions.DELIVER_FETCH_COURIERS_REQUEST:
    case deliverActions.DELIVER_FETCH_COURIERS_SUCCESS:
    case deliverActions.DELIVER_FETCH_COURIERS_ERROR:
      return update(state, {
        deliver: { $set: deliverReducer(state.deliver, (action: any)) },
      });
    case completedActions.COMPLETED_FETCH_DISBURSEMENT_REQUEST:
    case completedActions.COMPLETED_FETCH_DISBURSEMENT_SUCCESS:
    case completedActions.COMPLETED_FETCH_DISBURSEMENT_ERROR:
      return update(state, {
        completed: { $set: completedReducer(state.completed, (action: any)) }
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/order/Sale/duck.js